<template>
    <div>
        <v-snackbar
            v-model="snackbar"
            :color="color"
            :timeout="duration"
            top
            right
        >
            {{ message }}
        </v-snackbar>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';

export default {
    data() {
        return {
            snackbar: false,
            dialog: false,
            message: '',
            confirmMessage: '',
            color: '',
            duration: 3000,
            confirmCallback: null,
            cancelCallback: null,
            confirmationInProgress: false,
        };
    },
    created() {
        EventBus.$on('notify', this.showNotification);
    },
    beforeDestroy() {
        EventBus.$off('notify', this.showNotification);
    },
    methods: {
        showNotification({ message, type, duration }) {
            this.message = message;
            this.duration = duration || 3000;
            this.color = {
                success: 'green',
                warning: 'orange darken-2',
                danger: 'red',
            }[type] || 'primary';
            this.snackbar = true;
        },
    },
};
</script>
